/**
 * CENTRALIZED API CONFIGURATION
 * 
 * This is the SINGLE SOURCE OF TRUTH for the backend URL.
 * All files must import from here - DO NOT read process.env.REACT_APP_BACKEND_URL directly.
 * 
 * Production Safety:
 * - On production (newaudia.com): Uses SAME-ORIGIN (empty string) so all /api/... calls
 *   are relative to current domain. This avoids CORS and allows future API domain changes.
 * - On preview/dev: Uses REACT_APP_BACKEND_URL from .env
 */

// Environment backend (for preview/development)
const ENV_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

// Detect production environment
const isProduction = typeof window !== 'undefined' && window.location.hostname.includes('newaudia.com');

// THE BACKEND URL
// Production: same-origin (empty string) - all /api/... calls are relative
// Preview/Dev: explicit URL from .env
export const BACKEND_URL = isProduction ? '' : ENV_BACKEND_URL;

// Also export as API_URL for compatibility
export const API_URL = BACKEND_URL;

// Export environment info for debugging
export const IS_PRODUCTION = isProduction;

// Log on module load (only in browser)
if (typeof window !== 'undefined') {
  console.log(`[API Config] Environment: ${isProduction ? 'PRODUCTION' : 'development/preview'}`);
  if (isProduction) {
    console.log('[API Config] Using same-origin for API calls (relative /api/...)');
  } else {
    console.log(`[API Config] Backend URL: ${BACKEND_URL}`);
  }
}
